import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Navigation from "./components/navigation/navigation.component";
import { GlobalStyle } from "./global.styles";

import AppLoyout from "./routes/apployout";

function App() {
  const location = useLocation();
  const showLegacyNavigation =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/partner");

  useEffect(() => {
    const queryUserId = new URLSearchParams(window.location.search).get("user_id");
    const telegramUserId = (window as any).Telegram?.WebApp?.initDataUnsafe?.user?.id?.toString();
    const userId = queryUserId || telegramUserId;

    if (userId && /^\d+$/.test(userId)) {
      localStorage.setItem("userId", userId);
    }
  }, []);

  return (
    <div>
      <GlobalStyle />
      <AppLoyout />
      {showLegacyNavigation && <Navigation />}
    </div>
  );
}

export default App;
